// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Loader_Loader__9xAFB","preLoader":"Loader_preLoader__6u1Ls","loader":"Loader_loader__yypPT"};